import { AxiosError } from 'axios'

interface IReturnError {
    message: string
    status?: number
}

export default function errorHandler(error: unknown): IReturnError {
    if (error instanceof AxiosError) {
        const { request, response } = error

        if (response && response.data) {
            const { message } = response.data
            const { status } = response

            return {
                message,
                status,
            }
        }

        if (request) {
            return {
                message: 'Server time out',
                status: 503,
            }
        }

        return {
            message: 'opps! verifique a sua conexão com a internet',
        }
    }

    return {
        message: 'opps! Recarregue a página',
    }
}
